import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadCityList = async () => {
    try {
        const payload = {

            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        return await callApi(API_ENDPOINTS.Location_GET_ALL_CITY, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadCityListByStateID = async (payload) => {
    try {
        

        return await callApi(API_ENDPOINTS.Location_GET_CITY, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};


export const loadCountryList = async (para) => {
    try {
        const payload = {

            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        return await callApi(API_ENDPOINTS.Location_GET_COUNTRY, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};


export const loadStateListbyCountryID = async (payload) => {
    try {
        

        return await callApi(API_ENDPOINTS.Location_GET_STATE, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadAllStateList = async (payload) => {
    try {
        

        return await callApi(API_ENDPOINTS.Location_GET_ALL_CITY, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};